module.exports = __webpack_public_path__ + "src/assets/images/lock_icon.8b518a53fb25267a01181d415ed33107.svg";